<template>
  <details
    :open="open"
    :class="$style.root"
    :style="computedVars"
    data-collapsible-panel-ui-v="1.0.0"
  >
    <summary :class="$style.summary">
      <div :class="$style.header">
        <div :class="$style.headerCopy">
          <div v-if="title || $slots.title" :class="$style.title">
            {{ title }}
            <slot name="title"></slot>
          </div>

          <div v-if="subtitle || $slots.subtitle" :class="$style.subtitle">
            {{ subtitle }}
            <slot name="subtitle"></slot>
          </div>
        </div>
      </div>
    </summary>

    <div :class="$style.body">
      <slot />
    </div>
  </details>
</template>

<script setup lang="ts">
const props = defineProps<{
  title?: string
  subtitle?: string
  accentColor?: string
  open?: boolean
}>()

const computedVars = computed(() => ({
  '--collapsible-panel-accent': props.accentColor?.trim() || '#7A79C1',
}))
</script>

<style lang="scss" module>
.root {
  border: 1px solid var(--collapsible-panel-accent);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 0 0 20px;
}

.summary {
  list-style: none;
  cursor: pointer;
  background: linear-gradient(180deg, #2b2b31 0%, #1f1f24 100%);
  color: #fff;

  &::-webkit-details-marker {
    display: none;
  }

  &::marker {
    display: none;
    content: '';
  }
}

.header {
  border-left: 6px solid var(--collapsible-panel-accent);
  padding: 20px 22px 18px 18px;
}

.headerCopy {
  font-family: var(--roboto-condensed);
  font-weight: 700;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
}

.title {
  font-size: 24px;
  line-height: 1.08;
  letter-spacing: 0.015em;
}

.subtitle {
  margin-top: 8px;
  font-size: 18px;
  line-height: 1.15;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.66;
}

.body {
  padding: 22px 24px 8px;
  font-family: var(--base-font-family);
  font-size: 18px;
  line-height: 1.6;
  color: #111;
  background: linear-gradient(180deg, #fff 0%, #faf9ff 100%);

  > :last-child {
    margin-bottom: 16px;
  }
}
</style>
